"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var constants_1 = require("@/constants");
var Navigation_component_1 = require("@/components/common/Navigation/Navigation.component");
var styles_1 = require("@/styles");
var Styled = __importStar(require("./LNB.styled"));
var components_1 = require("@/components");
var application_svg_1 = __importDefault(require("@/assets/svg/application.svg"));
var application_form_svg_1 = __importDefault(require("@/assets/svg/application-form.svg"));
var email_svg_1 = __importDefault(require("@/assets/svg/email.svg"));
var activity_score_svg_1 = __importDefault(require("@/assets/svg/activity-score.svg"));
var schedule_svg_1 = __importDefault(require("@/assets/svg/schedule.svg"));
var recruit_svg_1 = __importDefault(require("@/assets/svg/recruit.svg"));
var faq_svg_1 = __importDefault(require("@/assets/svg/faq.svg"));
// import SignupCodeIcon from "@/assets/svg/signup-code.svg"
var admin_members_svg_1 = __importDefault(require("@/assets/svg/admin-members.svg"));
// import MyPageIcon from "@/assets/svg/my-page.svg"
var navigationItems = [
    {
        title: '리크루팅 관리',
        menus: [
            {
                label: '지원서',
                to: constants_1.PATH.APPLICATION,
                icon: (0, jsx_runtime_1.jsx)(application_svg_1.default, {}, void 0),
            },
            {
                label: '지원서 설문지',
                to: constants_1.PATH.APPLICATION_FORM,
                icon: (0, jsx_runtime_1.jsx)(application_form_svg_1.default, {}, void 0),
            },
            {
                label: '이메일 발송 내역',
                to: constants_1.PATH.EMAIL,
                icon: (0, jsx_runtime_1.jsx)(email_svg_1.default, {}, void 0),
            },
        ],
    },
    {
        title: '출석 체크 앱',
        menus: [
            {
                label: '활동점수',
                to: constants_1.PATH.ACTIVITY_SCORE,
                icon: (0, jsx_runtime_1.jsx)(activity_score_svg_1.default, {}, void 0),
            },
            {
                label: '스케줄 정보',
                to: constants_1.PATH.SCHEDULE,
                icon: (0, jsx_runtime_1.jsx)(schedule_svg_1.default, {}, void 0),
            },
            // TODO: 추가 예정 메뉴
            // {
            //   label: '가입 코드',
            //   to: PATH.SIGNUP_CODE,
            // },
        ],
    },
    // TODO: 추가 예정 메뉴
    {
        title: '콘텐츠 관리',
        menus: [
            {
                label: '모집 공고',
                to: constants_1.PATH.RECRUIT,
                icon: (0, jsx_runtime_1.jsx)(recruit_svg_1.default, {}, void 0),
            },
            {
                label: '자주 묻는 질문',
                to: constants_1.PATH.FAQ,
                icon: (0, jsx_runtime_1.jsx)(faq_svg_1.default, {}, void 0),
            },
        ],
    },
    {
        title: '계정 관리',
        menus: [
            {
                label: '계정 목록',
                to: constants_1.PATH.ADMIN_MEMBERS,
                icon: (0, jsx_runtime_1.jsx)(admin_members_svg_1.default, {}, void 0),
                isMasterOnly: true,
            },
            // {
            //   label: '내 정보',
            //   to: PATH.MY_PAGE,
            // },
        ],
    },
];
var LNB = function () {
    return ((0, jsx_runtime_1.jsx)(Styled.LNBContainer, { children: (0, jsx_runtime_1.jsx)(components_1.Navigation, { size: Navigation_component_1.NavigationSize.md, items: navigationItems, inActiveColor: styles_1.colors.gray70, showBottomBorder: false }, void 0) }, void 0));
};
exports.default = LNB;
